module.exports = __webpack_public_path__ + "img/bsi.ed50c4bc.png";